import React from 'react';
import { Row, Col } from 'reactstrap';
import { Input, Select } from '../../lib/form-field';

const FormDemMeta = ({ demTemplateOptions, campaignOptions }) => {
  return (
    <>
      <Row>
        <Col md="12">
          <Input type="text" name="name" id="name" label="DEM Name" required />
        </Col>
        <Col md="12">
          <Input
            type="textarea"
            name="description"
            id="description"
            label="Description"
            rows={2}
          />
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Select
            name="demTemplateId"
            id="demTemplateId"
            label="DEM Template"
            required
            options={demTemplateOptions}
          />
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Select
            name="campaignId"
            id="campaignId"
            label="Campaign"
            isSearchable
            options={campaignOptions}
          />
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Input
            type="url"
            name="landingPageUrl"
            id="landingPageUrl"
            label="Landing page URL"
            required
          />
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <Input
            type="text"
            name="utmSource"
            id="utmSource"
            label="UTM Source"
            placeholder="e.g. newsletter"
          />
        </Col>
        <Col md="4">
          <Input
            type="text"
            name="utmMedium"
            id="utmMedium"
            label="UTM Medium"
            placeholder="e.g. email"
          />
        </Col>
        <Col md="4">
          <Input
            type="text"
            name="utmCampaign"
            id="utmCampaign"
            label="UTM Campaign"
            placeholder="e.g. spring_sale"
          />
        </Col>
      </Row>
    </>
  );
};

export default FormDemMeta;
